module.exports = __webpack_public_path__ + "img/first_zhCn.0ee79f4c.png";